import { Button, Modal, ModalBody, ModalHead } from '@dixa/lib-shared-habla';
import { Organization } from 'lib-shared-types-api';
import { Component } from 'react';

import AjaxLoader from '../../../../../ajax/components/AjaxLoader';
import styles from '../../waitMusic/waitMusic.module.scss';

import { BrowserTab } from './Browse';
import UploadTab from './Upload';

type PropsT = {
  selectedAudio: any;
  meta: any;
  organization: Organization;
  allAudios: Array<any>;
  isNewAudioOpen: boolean;
  isHoldingOpen: boolean;
  optional: boolean | null;
  jobIds: Array<any>;

  holdMusicGetAll: () => Promise<any>;
  holdMusicUpload: () => Promise<any>;
  holdMusicSplit: () => Promise<any>;
  audioReset: () => void;
  audioShowModal: () => void;
  audioHideModal: () => void;
  holdMusicSelect: (payload: { selectedAudio: any }) => void;
  holdMusicHoldingForSplitingOpen: () => void;
  holdMusicHoldingForSplitingClose: () => void;
};

type StateT = {
  showUpload?: boolean;
  showRecord?: boolean;
  showNew?: boolean;
  showUploadTab: boolean;
};

export default class HoldMusicWithPlayer extends Component<PropsT, StateT> {
  constructor(props: PropsT) {
    super(props);
    this.state = {
      showUploadTab: false,
    };
  }

  componentDidMount() {
    this.props.holdMusicGetAll().then((response: any) => {
      if (response.data && response.data.wait_music) {
        for (const music of response.data.wait_music) {
          if (music.uuid === this.props.organization.default_hold_music_id) {
            const currentMusic = Object.assign({}, music, { id: music.uuid });
            this.props.holdMusicSelect({ selectedAudio: currentMusic });
          }
        }
      }
    });
  }

  componentWillUnmount() {
    this.props.audioReset();
  }

  audioHideModalHandler = () => {
    this.props.audioHideModal();
  };

  render() {
    let tryAgainBtn: JSX.Element | null = null;

    if (this.props.meta.getAsyncStatus === 'failed') {
      tryAgainBtn = (
        <div className="text-center">
          <Button
            variant="danger"
            onClick={() => {
              this.props.holdMusicGetAll();
            }}
          >
            Error on fetch audio - try again
          </Button>
        </div>
      );
    }

    return (
      <div className={styles.audioHolder}>
        <div className={styles.sectionHeader}>
          <h5>Audio File</h5>
          {this.state.showUploadTab ? (
            <Button
              type="button"
              variant="tertiary"
              onClick={() => this.setState({ showUploadTab: false })}
            >
              -Hide uploader
            </Button>
          ) : (
            <Button
              type="button"
              variant="tertiary"
              onClick={() => this.setState({ showUploadTab: true })}
            >
              +Add new
            </Button>
          )}
        </div>

        <div className={styles.browseAudio}>
          {tryAgainBtn}
          <BrowserTab
            waitMusicSelect={this.props.holdMusicSelect}
            {...(this.props as any)}
          />
          {this.state.showUploadTab && (
            <div>
              {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                <UploadTab
                  meta={this.props.meta}
                  selectedAudio={this.props.selectedAudio}
                  waitMusicUpload={this.props.holdMusicUpload}
                  waitMusicSplit={this.props.holdMusicSplit}
                  waitMusicWaitingForSplitingOpen={
                    this.props.holdMusicHoldingForSplitingOpen
                  }
                  waitMusicWaitingForSplitingClose={
                    this.props.holdMusicHoldingForSplitingOpen
                  }
                />
              }
            </div>
          )}

          <Modal
            className={styles.waitingForSpilitingModal}
            isOpen={this.props.isHoldingOpen}
            onClose={this.props.holdMusicHoldingForSplitingClose}
          >
            <ModalHead
              title="Almost done"
              onClose={this.props.holdMusicHoldingForSplitingClose}
            ></ModalHead>
            <ModalBody>
              <div>
                <h3 style={{ textAlign: 'center' }}>
                  Please wait while preparing your audio file.
                </h3>
                <p>
                  {this.props.jobIds.length > 0 &&
                    `${this.props.jobIds.length} is waiting to be completed...`}
                </p>
                <AjaxLoader />
              </div>
            </ModalBody>
          </Modal>
        </div>
      </div>
    );
  }
}
